export const CPL_ITEM_STATUS_FILTERS = [
    { value: -1, label: 'Priority', disabled: false },
    { value: -2, label: 'A-Z', disabled: false },
    { value: -4, label: 'Due Date', disabled: false },
    { value: null, label: '-------------', disabled: true },
    { value: -3, label: 'Archived', disabled: false },
    { value: null, label: '-------------', disabled: true },
    { value: -5, label: 'Waiting on User', disabled: false },
    { value: 0, label: 'Not Expiring', disabled: false },
    { value: 2, label: 'Expiring', disabled: false },
    { value: 4, label: 'Expired', disabled: false },
    { value: 9, label: 'Expired (All Cycles)', disabled: false },
    { value: 3, label: 'Pending', disabled: false },
    { value: 6, label: 'Disapproved', disabled: false },
    { value: 7, label: 'Forgiven', disabled: false },
    { value: 1, label: 'Approved', disabled: false }
] as const;

export const REQUEST_ITEM_STATUS_FILTERS = [
    { value: -1, label: 'Priority', disabled: false },
    { value: -2, label: 'A-Z', disabled: false },
    { value: -4, label: 'Due Date', disabled: false },
    { value: null, label: '-------------', disabled: true },
    { value: -3, label: 'Archived', disabled: false },
    { value: null, label: '-------------', disabled: true },
    { value: 1, label: 'Submitted/Pending', disabled: false },
    { value: -5, label: 'Waiting on Follow Up', disabled: false },
    { value: 5, label: 'Follow Up Not Expiring', disabled: false },
    { value: 10, label: 'Follow Up Expiring', disabled: false },
    { value: 11, label: 'Follow Up Expired', disabled: false },
    { value: 6, label: 'Follow Up Submitted', disabled: false },
    { value: -6, label: 'Follow Up Forgiven', disabled: false },
    { value: 3, label: 'Disapproved', disabled: false },
    { value: 8, label: 'Completed', disabled: false },
    { value: 9, label: 'Cancelled', disabled: false }
] as const;

export const A48_STATUS_FILTERS = [
    { value: null, label: 'Act 48 - All', disabled: false },
    { value: -1, label: 'Not Submitted', disabled: false },
    { value: 0, label: 'Overriden', disabled: false },
    { value: 1, label: 'Pending Submission', disabled: false },
    { value: 2, label: 'Error on Submission', disabled: false },
    { value: 3, label: 'Submitted to PERMS', disabled: false },
    { value: 5, label: 'Para Hours Approved', disabled: false },
    { value: 6, label: 'Excluded from Submission', disabled: false }
] as const;


